import requestUtils from 'api/requestUtils'
import qs from 'qs'

interface ServerOffer {
  id: string
  title: string
  basePrice: number
  publicPrice: number
  currency: string
  discountPercent: number
  basePoints: number
  bonusPoints: number
  totalPoints: number
  bonusPointsPercent: number
  isEligibleNow?: boolean
  nextEligiblePurchaseDate?: string | null
}

interface ServerResponse {
  result: Array<ServerOffer>
}

function mapOffer(offer: ServerOffer): App.LoyaltyPurchasePointsOffer {
  return {
    id: offer.id,
    title: offer.title,
    basePrice: offer.basePrice,
    publicPrice: offer.publicPrice,
    currency: offer.currency,
    discountPercent: offer.discountPercent,
    basePoints: offer.basePoints,
    bonusPoints: offer.bonusPoints,
    totalPoints: offer.totalPoints,
    bonusPointsPercent: offer.bonusPointsPercent,
    isEligibleNow: offer.isEligibleNow,
    nextEligiblePurchaseDate: offer.nextEligiblePurchaseDate ?? undefined,
  }
}

async function requestLoyaltyPurchasePointsOffers(
  currency: string,
  customerId?: string,
): Promise<Array<App.LoyaltyPurchasePointsOffer>> {
  const path = customerId
    ? `/api/lux-loyalty/customer/${encodeURIComponent(customerId)}/points/purchase-offers`
    : '/api/lux-loyalty/points/purchase-offers'

  const response = await requestUtils.get<ServerResponse>(
    `${path}?${qs.stringify({ currency })}`,
    customerId ? { credentials: 'include', excludeBrand: true } : { excludeBrand: true },
  )

  return response.result.map(mapOffer)
}

export default requestLoyaltyPurchasePointsOffers
